
export const SET_STATE_TO_INITIAL_VALUES = 'SET_STATE_TO_INITIAL_VALUES'

export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO'
export const ZET_CURRENT_SCREEN = 'ZET_CURRENT_SCREEN'
export const SET_CURSIST_INFO = 'SET_CURSIST_INFO'
export const GET_LEERLING_GENERAL = 'GET_LEERLING_GENERAL'
export const SET_OPLEIDING_LIST = 'SET_OPLEIDING_LIST'
export const SET_MODULE_LIST = 'SET_MODULE_LIST'
export const SET_GEVOLGDEOPLEIDING_LIST = 'SET_GEVOLGDEOPLEIDING_LIST'
export const ZET_CURRENT_OPLEIDING = 'ZET_CURRENT_OPLEIDINGS'
export const SET_BETALINGEN = 'SET_BETALINGEN'
export const SET_PARTICIPATION_LIST = 'SET_PARTICIPATION_LIST'










